var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"screenfull-container",on:{"click":_vm.handleToggleFullscreen}},[(!_vm.isFullscreen)?_c('i',{staticClass:"el-icon-full-screen screenfull-icon"}):_c('i',{staticClass:"el-icon-copy-document screenfull-icon"})])
}
var staticRenderFns = []

export { render, staticRenderFns }